import React, { Fragment, useEffect } from "react";
import { Listbox } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";

export default function HeightPicker({
  field_name,
  error,
  required,
  onChange,
  borderColor,
  activeElement,
  setActiveElement,
}) {
  const optionsForFeet = [
    "1 ft",
    "2 ft",
    "3 ft",
    "4 ft",
    "5 ft",
    "6 ft",
    "7 ft",
  ];
  const optionsForInch = [
    "0 in",
    "1 in",
    "2 in",
    "3 in",
    "4 in",
    "5 in",
    "6 in",
    "7 in",
    "8 in",
    "9 in",
    "10 in",
    "11 in",
  ];

  const [selectedFeet, setSelectedFeet] = React.useState();
  const [selectedInch, setSelectedInch] = React.useState();

  const [openFeet, setOpenFeet] = React.useState(false);
  const [openInch, setOpenInch] = React.useState(false);

  useEffect(() => {
    onChange(field_name, `${selectedFeet || ""} ${selectedInch || ""}`);
    setOpenFeet(false);
    setOpenInch(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field_name, selectedFeet, selectedInch]);

  return (
    <div className="w-1/2">
      <div
        className="relative flex w-full border rounded-lg bg-white"
        style={{ borderColor: error ? "#dc2626" : borderColor }}
      >
        <div className="relative w-full">
          <Listbox value={selectedFeet} onChange={setSelectedFeet}>
            <Listbox.Button
              onClick={() => { setOpenFeet(activeElement !== field_name ? true : !openFeet); setActiveElement(field_name); }}
              className={`peer flex justify-between items-center h-12 w-full disabled:opacity-60 ${
                error ? "!text-red-600" : "!text-gray-800"
              } px-4 py-2 bg-white text-md
                font-medium rounded-l-lg placeholder-transparent outline-none ${
                  error ? "ring-err-base" : ""
                } input-invalid`}
              style={{ borderColor: error ? "#dc2626" : borderColor }}
            >
              {selectedFeet && <label>{selectedFeet}</label>}
              {!selectedFeet && <label className="text-gray-400">ft</label>}
              <span className="">
                <ChevronDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>
            {openFeet && activeElement === field_name && (
              <Listbox.Options static className="absolute mt-1 z-50 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {optionsForFeet.map((value) => (
                  <Listbox.Option
                    key={value}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-6 pr-4 ${
                        active
                          ? "bg-neutral-100 text-black"
                          : "bg-white text-black"
                      }`
                    }
                    value={value}
                  >
                    {({ selectedFeet }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selectedFeet ? "font-medium" : "font-normal"
                          }`}
                        >
                          {value}
                        </span>
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            )}
          </Listbox>
        </div>

        <div className="relative w-full">
          <Listbox value={selectedInch} onChange={setSelectedInch}>
            <Listbox.Button
              onClick={() => { setOpenInch(activeElement !== field_name ? true : !openInch); setActiveElement(field_name); }}
              className={`peer flex justify-between items-center h-12 w-full disabled:opacity-60 ${
                error ? "!text-red-600" : "!text-gray-800"
              } px-4 py-2 bg-white text-md
                font-medium rounded-r-lg placeholder-transparent outline-none ${
                  error ? "ring-err-base" : ""
                } input-invalid`}
              style={{ borderColor: error ? "#dc2626" : borderColor }}
            >
              {selectedInch && <label>{selectedInch}</label>}
              {!selectedInch && <label className="text-gray-400">in</label>}
              <span className="">
                <ChevronDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>
            {openInch && activeElement === field_name && (
              <Listbox.Options static className="absolute mt-1 z-50 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {optionsForInch.map((value) => (
                  <Listbox.Option
                    key={value}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-6 pr-4 ${
                        active
                          ? "bg-neutral-100 text-black"
                          : "bg-white text-black"
                      }`
                    }
                    value={value}
                  >
                    {({ selectedInch }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selectedInch ? "font-medium" : "font-normal"
                          }`}
                        >
                          {value}
                        </span>
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            )}
          </Listbox>
        </div>
      </div>
      {error && (
        <div className="text-red-600 ml-4 text-sm px-2 -bottom-2 bg-white rounded absolute">
          {error}
        </div>
      )}
    </div>
  );
}
